module.exports = __webpack_public_path__ + "static/img/017.ec8940e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-headquarters/017.png
// module id = hLCJ
// module chunks = 1